<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:PagePrivacy -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ titleinfo[getCurrentLocale] }}</h1>
                        </div>
                        <br />

                        <div class="booking-information sdr-box">
                            <h4 v-html="seat_h4_1[getCurrentLocale]"></h4>
                            <p v-html="seat_p_1[getCurrentLocale]"></p>
                            <p v-html="seat_p_2[getCurrentLocale]"></p>
                            <p v-html="seat_p_3[getCurrentLocale]"></p>


                            <br /><h5 v-html="seat_h5_1[getCurrentLocale]"></h5>
                            <p v-html="seat_p_4[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="seat_li_1[getCurrentLocale]"></li>
                                <li v-html="seat_li_2[getCurrentLocale]"></li>
                                <li v-html="seat_li_3[getCurrentLocale]"></li>
                                <li v-html="seat_li_4[getCurrentLocale]"></li>
                                <li v-html="seat_li_5[getCurrentLocale]"></li>
                            </ul>
                            <p v-html="seat_p_5[getCurrentLocale]"></p>
                            <p v-html="seat_p_6[getCurrentLocale]"></p>


                            <br /><h5 v-html="seat_h5_2[getCurrentLocale]"></h5>
                            <p v-html="seat_p_7[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="seat_li_1_1[getCurrentLocale]"></li>
                                <li v-html="seat_li_2[getCurrentLocale]"></li>
                                <li v-html="seat_li_3[getCurrentLocale]"></li>
                                <li v-html="seat_li_4[getCurrentLocale]"></li>
                                <li v-html="seat_li_5[getCurrentLocale]"></li>
                            </ul>
                            <p v-html="seat_p_8[getCurrentLocale]"></p>
                            <p v-html="seat_p_9[getCurrentLocale]"></p>


                            <br /><br /><p v-html="seat_p_10[getCurrentLocale]"></p>
                            <p>{{ phone[getCurrentLocale] }}:  +49 (0)30 53 67 67 91<br />
                            {{ email[getCurrentLocale] }}: <a href="mailto:kundenservice@sundair.com">Kundenservice@Sundair.com</a></p>
                        </div>
                    </div>
                    <!-- End:PagePrivacy -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->


        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Notes on seat reservation',
                    de: 'Hinweise zur Sitzplatzreservierung',
                },
                // >>> --------------------------
                seat_h4_1: {
                    en: 'Seat reservation',
                    de: 'Sitzplatzreservierung',
                },
                seat_p_1: {
                    en: 'We recommend a timely seat reservation no later than 7 days prior departure. A seat reservation can be made after an only-flight booking or by booking of a holiday package on the SUNDAIR website under <a href="/services">Service</a>.',
                    de: 'Wir empfehlen eine rechtzeitige Sitzplatzreservierung bis spätestens 7 Tage vor Abflug. Die Sitzplatzreservierung kann auch nach Ihrer Flugbuchung oder Ihrer Buchung der Pauschalreise unter <a href="/services">Service</a> vorgenommen werden.',
                },
                seat_p_2: {
                    en: 'Seat reservations are valid from last German airport to the first foreign country airport and vice versa.',
                    de: 'Ihre Sitzplatzreservierung ist gültig vom letzten deutschen Flughafen bis zum ersten Auslandsflughafen und umgekehrt.',
                },
                seat_p_3: {
                    en: 'In case of any aircraft type change, unfortunately seat reservations can’t be considered.',
                    de: 'Bei einem Flugzeugmuster-Wechsel kann Ihre Sitzplatzreservierung leider nicht berücksichtigt werden.',
                },
                // >>> --------------------------
                seat_h5_1: {
                    en: 'Emergency exit seats',
                    de: 'Sitzplätze am Notausgang',
                },
                seat_p_4: {
                    en: 'Emergency exit seats are subject to special security regulations. SUNDAIR is entitled to refuse any exit seat reservations for following group of people:',
                    de: 'Sitzplätze am Notausgang unterliegen besonderen Sicherheitsbestimmungen. SUNDAIR ist daher berechtigt, eine Buchung dieser Sitzplatzkategorie an folgende Personenkreise abzulehnen:',
                },
                seat_li_1: {
                    en: 'Infants and minors (up to 17 years)',
                    de: 'Kleinkinder und Kinder (bis einschließlich 17 Jahre)',
                },
                seat_li_1_1: {
                    en: 'Infants (up to 2 years)',
                    de: 'Kleinkinder (bis einschließlich 2 Jahre)',
                },
                seat_li_2: {
                    en: 'Pregnant women',
                    de: 'Schwangere',
                },
                seat_li_3: {
                    en: 'Passengers with reduced mobility',
                    de: 'Personen, die eingeschränkt mobil sind',
                },
                seat_li_4: {
                    en: 'Passengers which are limited in mobility due to their body size, illness or age',
                    de: 'Personen, die durch ihre Körpermaße, Krankheit oder aus Altersgründen eingeschränkt beweglich sind',
                },
                seat_li_5: {
                    en: 'Passengers travelling with pets in the cabin',
                    de: 'Personen, die Tiere in der Kabine mitführen',
                },
                seat_p_5: {
                    en: 'With the reservation of an emergency exit seat, the passenger agrees that the afore mentioned criteria don’t apply to them and the people he booked for. Additionally, the passenger has to be ready for helping flight personal in case of any emergency situation. This requires that the passenger is able to follow the instructions from flight personal in German or in English language.',
                    de: 'Mit der Reservierung eines Sitzplatzes am Notausgang sichert der Fluggast zu, dass die oben genannten Kriterien für ihn und die von ihm gebuchten Personen nicht zutreffen. Darüber hinaus muss der Fluggast bereit sein, dem Bordpersonal im Notfall behilflich zu sein. Dies setzt voraus, dass der Fluggast den Anweisungen des Bordpersonals in deutscher oder englischer Sprache Folge leisten kann.',
                },
                seat_p_6: {
                    en: 'Other than described SUNDAIR is entitled to allocate another seat to the affected person without the possibility to claim any refunding of booking fees. In the event of no seat allocation under consideration of any possibilities, SUNDAIR is entitled to refuse the transportation.',
                    de: 'Sollte dies nicht der Fall sein, ist SUNDAIR berechtigt, der betreffenden Person einen anderen Sitzplatz zuzuweisen, ohne dass ein Anspruch auf Rückerstattung der Reservierungskosten besteht. Sollte eine anderweitige Zuweisung eines Sitzplatzes unter Ausschöpfung aller Möglichkeiten nicht möglich sein, hat SUNDAIR das Recht, die Beförderung insgesamt zu verweigern.',
                },
                // >>> --------------------------
                seat_h5_2: {
                    en: 'Seating in Row 1',
                    de: 'Sitze in Reihe 1',
                },
                seat_p_7: {
                    en: 'Seats in Row 1 are subject to special security regulations. SUNDAIR is entitled to refuse such seat category to following group of people:',
                    de: 'Sitzplätze in Reihe 1 unterliegen besonderen Sicherheitsbestimmungen. SUNDAIR ist daher berechtigt, eine Buchung dieser Sitzplatzkategorie an folgende Personenkreise abzulehnen:',
                },
                seat_p_8: {
                    en: 'With the reservation of a seat in row 1, the passenger agrees that the afore mentioned criteria don’t apply to them and the people he booked for.',
                    de: 'Mit der Reservierung eines Sitzplatzes in Reihe 1 sichert der Fluggast zu, dass die obengenannten Kriterien für ihn und die von ihm gebuchten Personen nicht zutreffen.',
                },
                seat_p_9: {
                    en: 'Other than described SUNDAIR is entitled to allocate another seat to the affected person without the possibility to claim any refunding of booking fees. In the event of no seat allocation under consideration of any possibilities, SUNDAIR is entitled to refuse the transportation.',
                    de: 'Sollte dies nicht der Fall sein, ist SUNDAIR berechtigt, der betreffenden Person einen anderen Sitzplatz zuzuweisen, ohne dass ein Anspruch auf Rückerstattung der Reservierungskosten besteht. Sollte eine anderweitige Zuweisung eines Sitzplatzes unter Ausschöpfung aller Möglichkeiten nicht möglich sein, hat SUNDAIR das Recht, die Beförderung insgesamt zu verweigern.',
                },
                seat_p_10: {
                    en: 'Our service team is pleased to assist you for any further questions:',
                    de: 'Unser Serviceteam berät Sie gern und steht für weitere Fragen zur Verfügung:',
                },
                phone: {
                    en: 'Phone',
                    de: 'Tel.',
                },
                email: {
                    en: 'E-mail',
                    de: 'E-Mail',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ])

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    ul.arrow, ul.triangle, ul.circle, ul.check, ul.chevron, ul.arrow-square, ul.check-square, ul.check-circle, ul.decimal, ul.upper-roman, ul.lower-latin, ul.upper-latin {
        font-size: 1.0833em;
    }





    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.6em;
        }
        .booking-information {
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 30px;
            padding-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/infos/seat-reservation/Home.vue